/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import {
  ProjectChildrenFragmentDoc,
  ProjectFragmentDoc,
  ProjectSpecialPriceGroupsFragmentDoc
} from "../../../entities/projects/graphql/fragments.generated"
import * as Types from "../../../shared/types/__generated__/graphql"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type ProjectByShareLinkQueryVariables = Exact<{
  id: string
}>

export type ProjectByShareLinkQuery = {
  __typename: "Query"
  projectByShareLink?: {
    __typename: "Project"
    id: string
    title: string
    description?: string | null
    position: number
    priceList?: string | null
    inflationSurcharge?: number | null
    createdAt: string
    updatedAt: string
    lastChanged?: string | null
    hasClarificationRequest?: boolean | null
    ui?: { __typename: "ProjectUI"; color?: string | null } | null
    lastChangedBy?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
    phase?: {
      __typename: "ProjectPhase"
      id: string
      value: string
      label: string
    } | null
    team?: { __typename: "ProjectTeamID"; id: string } | null
  } | null
}

export type ProjectChildrenByShareLinkQueryVariables = Exact<{
  id: string
}>

export type ProjectChildrenByShareLinkQuery = {
  __typename: "Query"
  projectByShareLink?: {
    __typename: "Project"
    id: string
    title: string
    description?: string | null
    position: number
    priceList?: string | null
    inflationSurcharge?: number | null
    createdAt: string
    updatedAt: string
    lastChanged?: string | null
    hasClarificationRequest?: boolean | null
    ui?: { __typename: "ProjectUI"; color?: string | null } | null
    lastChangedBy?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
    phase?: {
      __typename: "ProjectPhase"
      id: string
      value: string
      label: string
    } | null
    team?: { __typename: "ProjectTeamID"; id: string } | null
    children?: Array<
      | {
          __typename: "Floor"
          id: string
          label?: string | null
          position: number
          createdAt: string
          updatedAt: string
          remark?: string | null
          hasClarificationRequest?: boolean | null
          children?: Array<{
            __typename: "Room"
            id: string
            label?: string | null
            number: string
            area?: number | null
            volume?: number | null
            utilization?: string | null
            height?: number | null
            personsNumber?: number | null
            airVolumePerArea?: number | null
            airVolumePerPerson?: number | null
            remark?: string | null
            sup?: number | null
            oda?: number | null
            eta?: number | null
            eha?: number | null
            tra?: number | null
            rca?: number | null
            ida?: number | null
            sec?: number | null
            soundPressureLevel?: number | null
            position: number
            createdAt: string
            updatedAt: string
            hasClarificationRequest?: boolean | null
            children?: Array<{
              __typename: "ProductPosition"
              id: string
              label?: string | null
              variantKey: string
              configurationKey?: string | null
              remark?: string | null
              quantity: number
              position: number
              displayPosition?: string | null
              isAlternative?: boolean | null
              price?: number | null
              priceGroup?: string | null
              hasClarificationRequest?: boolean | null
              references?: Array<{
                __typename: "ProductPositionInstallationReference"
                id: string
                title?: string | null
                permalink: string
                position: number
              }> | null
              addons?: Array<{
                __typename: "ProductPositionAddon"
                id: string
                variantKey: string
                parentProductType: string
              }> | null
              dimensioning?: {
                __typename: "ExternalDimensioningResult"
                transactionId: string
                environmentalVars?: Array<any> | null
                variantKeyData?: any
                dllVersion?: string | null
                language?: string | null
                technicalData?: Array<
                  | {
                      __typename: "ExternalDimensioningTechnicalDataDllVersion"
                      dllVersion: string
                    }
                  | {
                      __typename: "ExternalDimensioningTechnicalDataTable"
                      header?: Array<string> | null
                      content?: any
                      summary?: string | null
                      type?: string | null
                    }
                > | null
                technicalInput?: Array<{
                  __typename: "ExternalDimensioningTechnicalInput"
                  name: string
                  label?: string | null
                  unit?: string | null
                  value?: any
                  userSelected: boolean
                }> | null
                supplementaryText?: Array<{
                  __typename: "ExternalDimensioningSupplementaryText"
                  text: string
                }> | null
                transferData?: {
                  __typename: "ExternalDimensioningTransferData"
                  origin?: string | null
                } | null
              } | null
            }> | null
          }> | null
        }
      | {
          __typename: "ProductPosition"
          id: string
          label?: string | null
          variantKey: string
          configurationKey?: string | null
          remark?: string | null
          quantity: number
          position: number
          displayPosition?: string | null
          isAlternative?: boolean | null
          price?: number | null
          priceGroup?: string | null
          hasClarificationRequest?: boolean | null
          references?: Array<{
            __typename: "ProductPositionInstallationReference"
            id: string
            title?: string | null
            permalink: string
            position: number
          }> | null
          addons?: Array<{
            __typename: "ProductPositionAddon"
            id: string
            variantKey: string
            parentProductType: string
          }> | null
          dimensioning?: {
            __typename: "ExternalDimensioningResult"
            transactionId: string
            environmentalVars?: Array<any> | null
            variantKeyData?: any
            dllVersion?: string | null
            language?: string | null
            technicalData?: Array<
              | {
                  __typename: "ExternalDimensioningTechnicalDataDllVersion"
                  dllVersion: string
                }
              | {
                  __typename: "ExternalDimensioningTechnicalDataTable"
                  header?: Array<string> | null
                  content?: any
                  summary?: string | null
                  type?: string | null
                }
            > | null
            technicalInput?: Array<{
              __typename: "ExternalDimensioningTechnicalInput"
              name: string
              label?: string | null
              unit?: string | null
              value?: any
              userSelected: boolean
            }> | null
            supplementaryText?: Array<{
              __typename: "ExternalDimensioningSupplementaryText"
              text: string
            }> | null
            transferData?: {
              __typename: "ExternalDimensioningTransferData"
              origin?: string | null
            } | null
          } | null
        }
      | {
          __typename: "Room"
          id: string
          label?: string | null
          number: string
          area?: number | null
          volume?: number | null
          utilization?: string | null
          height?: number | null
          personsNumber?: number | null
          airVolumePerArea?: number | null
          airVolumePerPerson?: number | null
          remark?: string | null
          sup?: number | null
          oda?: number | null
          eta?: number | null
          eha?: number | null
          tra?: number | null
          rca?: number | null
          ida?: number | null
          sec?: number | null
          soundPressureLevel?: number | null
          position: number
          createdAt: string
          updatedAt: string
          hasClarificationRequest?: boolean | null
          children?: Array<{
            __typename: "ProductPosition"
            id: string
            label?: string | null
            variantKey: string
            configurationKey?: string | null
            remark?: string | null
            quantity: number
            position: number
            displayPosition?: string | null
            isAlternative?: boolean | null
            price?: number | null
            priceGroup?: string | null
            hasClarificationRequest?: boolean | null
            references?: Array<{
              __typename: "ProductPositionInstallationReference"
              id: string
              title?: string | null
              permalink: string
              position: number
            }> | null
            addons?: Array<{
              __typename: "ProductPositionAddon"
              id: string
              variantKey: string
              parentProductType: string
            }> | null
            dimensioning?: {
              __typename: "ExternalDimensioningResult"
              transactionId: string
              environmentalVars?: Array<any> | null
              variantKeyData?: any
              dllVersion?: string | null
              language?: string | null
              technicalData?: Array<
                | {
                    __typename: "ExternalDimensioningTechnicalDataDllVersion"
                    dllVersion: string
                  }
                | {
                    __typename: "ExternalDimensioningTechnicalDataTable"
                    header?: Array<string> | null
                    content?: any
                    summary?: string | null
                    type?: string | null
                  }
              > | null
              technicalInput?: Array<{
                __typename: "ExternalDimensioningTechnicalInput"
                name: string
                label?: string | null
                unit?: string | null
                value?: any
                userSelected: boolean
              }> | null
              supplementaryText?: Array<{
                __typename: "ExternalDimensioningSupplementaryText"
                text: string
              }> | null
              transferData?: {
                __typename: "ExternalDimensioningTransferData"
                origin?: string | null
              } | null
            } | null
          }> | null
        }
    > | null
    specialPriceGroups?: Array<{
      __typename: "SpecialPriceGroup"
      id: string
      name: string
      parentPriceGroup?: string | null
      productType: string
    }> | null
  } | null
}

export const ProjectByShareLinkDocument = gql`
  query ProjectByShareLink($id: ID!) {
    projectByShareLink(id: $id)
      @rest(
        type: "Project"
        endpoint: "project"
        path: "/project-list/share/projects/{args.id}"
      ) {
      ...Project
    }
  }
  ${ProjectFragmentDoc}
`

/**
 * __useProjectByShareLinkQuery__
 *
 * To run a query within a React component, call `useProjectByShareLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectByShareLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectByShareLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectByShareLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProjectByShareLinkQuery,
    ProjectByShareLinkQueryVariables
  > &
    (
      | { variables: ProjectByShareLinkQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProjectByShareLinkQuery,
    ProjectByShareLinkQueryVariables
  >(ProjectByShareLinkDocument, options)
}
export function useProjectByShareLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectByShareLinkQuery,
    ProjectByShareLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProjectByShareLinkQuery,
    ProjectByShareLinkQueryVariables
  >(ProjectByShareLinkDocument, options)
}
// @ts-ignore
export function useProjectByShareLinkSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectByShareLinkQuery,
    ProjectByShareLinkQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProjectByShareLinkQuery,
  ProjectByShareLinkQueryVariables
>
export function useProjectByShareLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectByShareLinkQuery,
        ProjectByShareLinkQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProjectByShareLinkQuery | undefined,
  ProjectByShareLinkQueryVariables
>
export function useProjectByShareLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectByShareLinkQuery,
        ProjectByShareLinkQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProjectByShareLinkQuery,
    ProjectByShareLinkQueryVariables
  >(ProjectByShareLinkDocument, options)
}
export type ProjectByShareLinkQueryHookResult = ReturnType<
  typeof useProjectByShareLinkQuery
>
export type ProjectByShareLinkLazyQueryHookResult = ReturnType<
  typeof useProjectByShareLinkLazyQuery
>
export type ProjectByShareLinkSuspenseQueryHookResult = ReturnType<
  typeof useProjectByShareLinkSuspenseQuery
>
export type ProjectByShareLinkQueryResult = Apollo.QueryResult<
  ProjectByShareLinkQuery,
  ProjectByShareLinkQueryVariables
>
export const ProjectChildrenByShareLinkDocument = gql`
  query ProjectChildrenByShareLink($id: ID!) {
    projectByShareLink(id: $id)
      @rest(
        type: "Project"
        endpoint: "project"
        path: "/project-list/share/projects/{args.id}?include=subtree"
      ) {
      ...Project
      ...ProjectChildren
      ...ProjectSpecialPriceGroups
    }
  }
  ${ProjectFragmentDoc}
  ${ProjectChildrenFragmentDoc}
  ${ProjectSpecialPriceGroupsFragmentDoc}
`

/**
 * __useProjectChildrenByShareLinkQuery__
 *
 * To run a query within a React component, call `useProjectChildrenByShareLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectChildrenByShareLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectChildrenByShareLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectChildrenByShareLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProjectChildrenByShareLinkQuery,
    ProjectChildrenByShareLinkQueryVariables
  > &
    (
      | { variables: ProjectChildrenByShareLinkQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProjectChildrenByShareLinkQuery,
    ProjectChildrenByShareLinkQueryVariables
  >(ProjectChildrenByShareLinkDocument, options)
}
export function useProjectChildrenByShareLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectChildrenByShareLinkQuery,
    ProjectChildrenByShareLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProjectChildrenByShareLinkQuery,
    ProjectChildrenByShareLinkQueryVariables
  >(ProjectChildrenByShareLinkDocument, options)
}
// @ts-ignore
export function useProjectChildrenByShareLinkSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectChildrenByShareLinkQuery,
    ProjectChildrenByShareLinkQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProjectChildrenByShareLinkQuery,
  ProjectChildrenByShareLinkQueryVariables
>
export function useProjectChildrenByShareLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectChildrenByShareLinkQuery,
        ProjectChildrenByShareLinkQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProjectChildrenByShareLinkQuery | undefined,
  ProjectChildrenByShareLinkQueryVariables
>
export function useProjectChildrenByShareLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectChildrenByShareLinkQuery,
        ProjectChildrenByShareLinkQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProjectChildrenByShareLinkQuery,
    ProjectChildrenByShareLinkQueryVariables
  >(ProjectChildrenByShareLinkDocument, options)
}
export type ProjectChildrenByShareLinkQueryHookResult = ReturnType<
  typeof useProjectChildrenByShareLinkQuery
>
export type ProjectChildrenByShareLinkLazyQueryHookResult = ReturnType<
  typeof useProjectChildrenByShareLinkLazyQuery
>
export type ProjectChildrenByShareLinkSuspenseQueryHookResult = ReturnType<
  typeof useProjectChildrenByShareLinkSuspenseQuery
>
export type ProjectChildrenByShareLinkQueryResult = Apollo.QueryResult<
  ProjectChildrenByShareLinkQuery,
  ProjectChildrenByShareLinkQueryVariables
>
